import styled from 'styled-components'

const StDot = styled.div`
  ${({ color }) => `
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background-color: ${color};
  `}
`

export { StDot }
